var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#767676",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24a11.921 11.921 0 0 1-8.485-3.515A11.921 11.921 0 0 1 0 12C0 8.795 1.248 5.78 3.515 3.515A11.921 11.921 0 0 1 12 0c3.205 0 6.219 1.248 8.485 3.515A11.921 11.921 0 0 1 24 12c0 3.205-1.248 6.219-3.515 8.485A11.922 11.922 0 0 1 12 24Zm0-22.975A10.903 10.903 0 0 0 4.24 4.24 10.903 10.903 0 0 0 1.025 12c0 2.931 1.142 5.687 3.215 7.76A10.903 10.903 0 0 0 12 22.975c2.931 0 5.687-1.142 7.76-3.215A10.903 10.903 0 0 0 22.975 12c0-2.932-1.142-5.687-3.215-7.76A10.903 10.903 0 0 0 12 1.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.667h2.667v8h-2.667zM10.667 5.333h2.667V8h-2.667z"
  }))));
};
export default SvgInfo;